import Axios from "axios";
// Common
import {removeCookie} from "../common/cookie.service";
import {getSession} from "../common/session.service";
// Actions
import {setErrorApiMessage} from "../actions/apiFlag";
import {CHECK_IS_LOGGED, getSouscription, LOGOUT, saveUser, setRedirection} from "../actions/user";
import {
    setAddressStripeInfos,
    setCityStripeInfos,
    setCustomerId,
    setEmailStripeInfos,
    setFirstnameStripeInfos,
    setLastnameStripeInfos,
    setPostalCodeStripeInfos,
    setTelStripeInfos
} from "../actions/stripePayment";
// Utils
import {getApiBaseUrl, getBaseLoginUrl} from "../utils/baseUrl";

// On définit par défaut un TimeOut à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const auth = (store) => (next) => (action) => {
    switch (action.type) {
        case CHECK_IS_LOGGED : {
            const url = `${getApiBaseUrl()}/checkLogin/`;
            Axios.post(url, getSession(), {withCredentials: true})
                .then((res) => {
                    if (res.data.status === "success") {
                        // Dans la réponse data, on trouve toutes les informations sur l'utilisateur s'il elles existent
                        // On dispatch alors toutes ces informations
                        store.dispatch(saveUser(res.data.dataUser));
                        // Infos Stripe
                        store.dispatch(setFirstnameStripeInfos(res.data.dataUser.firstname));
                        store.dispatch(setLastnameStripeInfos(res.data.dataUser.name));
                        store.dispatch(setCityStripeInfos(res.data.dataUser.city));
                        store.dispatch(setAddressStripeInfos(res.data.dataUser.adress));
                        store.dispatch(setPostalCodeStripeInfos(res.data.dataUser.cp));
                        store.dispatch(setTelStripeInfos(res.data.dataUser.tel));
                        store.dispatch(setEmailStripeInfos(res.data.dataUser.email));
                        // Pas de redirection
                        store.dispatch(setRedirection(false));
                        if (res.data.dataUser.idStripe) {
                            // S'il existe un idStripe, on l'enregistre dans l'état global (correspond au customerId de Stripe)
                            store.dispatch(setCustomerId(res.data.dataUser.idStripe));
                        }
                        if (res.data.dataUser.idExt === "B2C") {
                            // Si le user est un client B2C, on veut savoir s'il a souscrit une offre payante
                            // ON appel donc le middleware getSouscription
                            store.dispatch(getSouscription());
                        }

                    }
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status === 401) {
                            console.log("errapireponse", err);
                            store.dispatch(setRedirection(true));
                        }
                    }
                    if (err) {
                        // Si l'api ne répond pas au bout de 10 seconde, on signale une erreur à l'utilisateur
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                            console.log("errapi", err);
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                            console.log("errapi", err);

                        }, 5000);
                    }
                });

            next(action);
            break;
        }
        case LOGOUT: {

            const url = `${getApiBaseUrl()}/logout/`;

            // Suppression des cookies mis en place en cochant la case "Se souvenir de moi" dans la page Login
            removeCookie("password", {path: "/"});
            removeCookie("email", {path: "/"});
            removeCookie("idUser", {path: "/"});

            Axios.post(url)
                .then(() => {
                    // On supprime le localstorage
                    window.localStorage.clear();
                    setTimeout(() => {
                        // Puis on redirige vers le module Login
                        window.location.href = `${getBaseLoginUrl()}`;
                    }, 5000);
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status === 401) {
                            store.dispatch(setRedirection(true));
                        }
                    }
                    if (err) {
                        // Si l'api ne répond pas au bout de 10 seconde, on signale une erreur à l'utilisateur
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        default:
            next(action);
    }
};

export default auth;